import script from "./clinic-reports.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-reports.vue?vue&type=script&setup=true&lang=js"

import "./clinic-reports.vue?vue&type=style&index=0&id=886eb512&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-886eb512"]])

export default __exports__